import { encryptData } from "../Encrypt/Encrypt";
import api from "./api";

// export const URL = "http://192.168.1.171:83"
export const URL = 'https://npsmanagement.thedestinysolutions.com'

export const IMAGE_URL = 'https://npsmanagement.thedestinysolutions.com'
// export const IMAGE_URL = 'http://192.168.1.171:83'


// Example: Get all client
export const getClient = () => {
  return api.post(`${URL}/api/CustomerReview/GetAllCustomerReview`);
};

// Example: Get all FAQs
export const getFAQs = () => {
  return api.post(`${URL}/api/FandQMaster/GetAllFandQMaster`);
};

// Example: Get all Category
export const getCategory = () => {
  return api.post(`${URL}/api/ChatGpt/GetAllCategory`);
};

// Example: Get all SubCategory
export const getSubCategory = () => {
  return api.post(`${URL}/api/ChatGpt/GetAllSubCategory`);
};

// Helper function to convert blob URL to File object
const convertBlobUrlToFile = async (fileData) => {
  if (!fileData.FilePath || !fileData.FilePath.startsWith('blob:')) {
    return null;
  }

  try {
    const response = await fetch(fileData.FilePath);
    const blob = await response.blob();
    return new File([blob], fileData.FileName, { type: fileData.FileType });
  } catch (error) {
    console.error('Error converting blob to file:', error);
    return null;
  }
};

export const getMessage = async (userDetails, prompt, currentFileData, selected, token, selectedOption) => {
  const Params = {
    CustomerID: userDetails?.CustomerID,
    CategoryID: selectedOption?.categoryId,
    SubCategoryID: selectedOption?.SubCategoryID,
    CustomerMessage: prompt,
    ChatGptPlan: selected?.id === 'free' ? 1 : 0,
    TransactionTypeID: 2,
  }

  console.log('object', currentFileData)
  // Create FormData
  const formData = new FormData();
  formData.append('payload', encryptData(Params));

  formData.append('Files', '[]');
  if (currentFileData) {
    const file = await convertBlobUrlToFile(currentFileData);
    if (file) {
      formData.append('ImageFile', file);
    }
  }
  console.log('Params ------- >', Params)

  return api.post(`${URL}/api/ChatGpt/GetChatGptMsg1`, formData, {
    headers: {
      Authorization: `bearer ${token}`,
      'Content-Type': 'multipart/form-data', // important for file upload
    },
  });
}

export const loginUser = async (formData) => {
  const Params = {
    PhoneNumber: formData.PhoneNumber,
    OTP: "",
    MPIN: formData.mpin,
    DeviceId: "",
    CustomerID: 0,
    ReferenceCode: "",
    IsMobile: false,
  };

  const payload = {
    payload: encryptData(Params),
  };

  return api.post(`${URL}/api/CustomerMaster/Login`, payload);
};

export const getCurrentPointsData = (userDetails, token) => {
  const Params = {
    TransactionTypeID: 0,
    CustomerID: userDetails?.CustomerID,
  };

  const payload = {
    payload: encryptData(Params),
  };

  return api.post(`${URL}/api/PointPlan/GetOrAddCurrentPointsData`, payload, {
    headers: {
      Authorization: `bearer ${token}`,
    },
  });
};

export const getAllPointPlans = () => {
  const payload = {
    payload: encryptData({}), // no params needed in this case
  };

  return api.post(`${URL}/api/PointPlan/GetAllPointPlan`, payload);
};


export const initiateCashFreePayment = (selectedId, customerId, token, TotalAmount) => {
  const params = {
    PointPlanID: selectedId,
    CustomerID: customerId,
    TotalAmount: TotalAmount,
  };

  const payload = {
    payload: encryptData(params),
  };

  return api.post(`${URL}/api/cashFreePayment/CashFreePaymentGateway`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};


export const ChatGptHistory = (userDetails, token) => {
  const params = {
    CategoryID: 0,
    CustomerID: userDetails?.CustomerID,
    SubCategoryID: 0,
  };

  const payload = { payload: encryptData(params) };

  return api.post(`${URL}/api/ChatGpt/GetChatGptHistory`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};


export const ChatGptPaymentDetails = (userDetails, selectedId, orderId, token) => {
  const params = {
    CustomerID: userDetails?.CustomerID,
    PointPlanID: selectedId,
    OderID: orderId,
    TransactionTypeID: 3,
  };

  const payload = {
    payload: encryptData(params),
  };

  return api.post(`${URL}/api/CashFreePayment/AddPaymentDetails`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const GetPointsHistory = (userDetails, token) => {
  const params = {
    CustomerID: userDetails?.CustomerID,
    TypeId: 4,
    FromDate: null,
    ToDate: null,
  };

  const payload = {
    payload: encryptData(params),
  };

  return api.post(`${URL}/api/PointPlan/GetPointsHistory`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const GetPaymentHistory = (userDetails, token) => {
  const params = {
    CustomerID: userDetails?.CustomerID,
    FromDate: null,
    ToDate: null,
  };

  const payload = {
    payload: encryptData(params),
  };

  return api.post(`${URL}/api/CashFreePayment/GetPaymentHistoryById`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};


export const GetGstCalculation = (userDetails, selectedId, token) => {
  const params = {
    CustomerID: userDetails?.CustomerID,
    PointPlanID: selectedId,
  };

  const payload = {
    payload: encryptData(params),
  };

  return api.post(`${URL}/api/CashFreePayment/GstCalculation`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const GetAppicationCustomberDetails = (item, token) => {
  const params = { ReferenceCode: item };
  const payload = { payload: encryptData(params) };
  return api.post(`${URL}/api/CustomerMaster/GetCustomerDetilasByCode`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};


export const Web_ChatGptPaymentDetails = (params, token) => {
  const payload = { payload: encryptData(params), };
  return api.post(`${URL}/api/CashFreePayment/AddPaymentDetailsForWeb`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};


export const Web_SendManagerRequestJoin = (params, token) => {
  const payload = { payload: encryptData(params), };
  return api.post(`${URL}/api/CustomerMaster/SendManagerRequest`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};


export const Web_partnerJoin = (params, token) => {
  const payload = { payload: encryptData(params), };
  return api.post(`${URL}/api/PartnerMaster/Web_partnerCreate`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// Get Bank Pension Data
export const getBankPensionData = (payload) => {
  const params = payload ? {
    Age: payload.Age || 0,
    Amount: parseFloat(payload.Amount) || 0,
    AnnuityFrequency: payload.AnnuityFrequency || "",
    AnnuityScheme: payload.AnnuityScheme || "",
    AnnuityValue: payload.AnnuityValue || ""
  } : {};

  const encryptedPayload = {
    payload: encryptData(params)
  };

  return api.post(`${URL}/api/PensionCalculatorWorkSectorMaster/GetBankPensionData`, encryptedPayload);
};

// Get Exit Form Data by PRAN Number
export const getExitFormByPran = (pranNumber, customerId) => {
  const params = {
    PranNumber: pranNumber || "",
    CustomerID: customerId || ""
  };
  const encryptedPayload = {
    payload: encryptData(params)
  };

  return api.post(`${URL}/api/ExitForm/GetAllExitFormByPran`, encryptedPayload);
};

// Generate Exit Form PDF
export const generateExitFormPDF = (payload) => {
  const encryptedPayload = {
    payload: encryptData(payload)
  };

  return api.post(`${URL}/api/ExitForm/AddorUpdateExitForm_Web`, encryptedPayload);
};

// Generate Exit Form PDF with FormData (for file uploads)
export const generateExitFormPDFWithFiles = (formData) => {
  return api.post(`${URL}/api/ExitForm/SaveDocument_Web`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Generate Exit Form PDF - Final API call
export const generateExitFormPDFFinal = (id) => {
  const payload = {
    ID: id
  };
  const encryptedPayload = {
    payload: encryptData(payload)
  };
  
  return api.post(`${URL}/api/Common/GenerateExitFormPDF`, encryptedPayload);
};
